// Generic Action Helper Types
export type SuccessResponse<T> = { success: true } & T;
type ErrorResponse<E> = { success: false } & E;
export type ActionResponse<T, E = { errorMessage: string }> = SuccessResponse<T> | ErrorResponse<E>;

// Convenience Default Action Error
export type DefaultActionError = { code: string | null; message: string };
export const DEFAULT_ACTION_ERROR: DefaultActionError = {
  code: 'uknown',
  message: 'unknown error',
};
